import React, { PureComponent } from 'react';
import TablaRow from './TablaRow'
import TablaRowDatosAdicionales from './TablaRowDatosAdicionales'

class TablaBody extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            estaDesplegado: false
        }

        this.setEstaDesplegado = this.setEstaDesplegado.bind(this);
    }

    setEstaDesplegado(estadoDesplegado) {        
        this.setState({
            estaDesplegado: estadoDesplegado 
        });
    }

    render() {
        const { state, setEstaDesplegado } = this;
        const { ajusteCargo, expandirRow, rowSeleccionada, tieneScroll, destildarTildarCheck, checkConfirmarArray, checkDenegarRestablecerArray, classScroll, user } = this.props;

        let ajustesRow = [];
        let checkConfirmar =  undefined;
        let checkDenegarRestablecer = undefined;

        if (ajusteCargo.length > 0) {
            ajusteCargo.map((ajusteCargo, index) => {
                let backColor = index % 2 != 0 ? ' backgroundTableLightBlue' : ''; 
                let claseFlecha = rowSeleccionada == ajusteCargo.Id ? "clickable none-text-decoration menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : "clickable none-text-decoration menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloDown"

                if ((checkConfirmarArray && checkConfirmarArray.length > 0) || (checkDenegarRestablecerArray && checkDenegarRestablecerArray.length > 0)) {
                    checkConfirmar = checkConfirmarArray.find(checkId => checkId == ajusteCargo.Id);
                    checkDenegarRestablecer = checkDenegarRestablecerArray.find(checkId => checkId == ajusteCargo.Id);
        
                    checkConfirmar = checkConfirmar ? true : false;
                    checkDenegarRestablecer = checkDenegarRestablecer ? true : false;
                }

                ajustesRow.push(
                    <TablaRow key={"Row " + ajusteCargo.Id}
                        ajusteCargo={ajusteCargo}
                        expandirRow={expandirRow}
                        claseFlecha={claseFlecha}
                        state={state}
                        setEstaDesplegado={setEstaDesplegado}
                        backColor={backColor}
                        tieneScroll={tieneScroll}
                        destildarTildarCheck={destildarTildarCheck}
                        checkConfirmar={checkConfirmar}
                        checkDenegarRestablecer={checkDenegarRestablecer}
                        user={user}
                    />
                );

                if (rowSeleccionada != undefined && rowSeleccionada == ajusteCargo.Id) {
                    ajustesRow.push(
                        <TablaRowDatosAdicionales key={"RowAdicional " + ajusteCargo.Id} ajusteCargo={ajusteCargo} />
                    );
                }
            });
        }

        return (
            <tbody className={"confirmadorAjusteCargoScroll" + classScroll}>
                {ajustesRow}
            </tbody>);
    }
}

export default TablaBody;